import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { SiteProvider } from "@/context/SiteContext";
import { Layout } from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AdminRoute } from "@/components/AdminRoute";
import Home from "@/pages/Home";
import Marketplace from "@/pages/Marketplace";
import ChefProfile from "@/pages/ChefProfile";
import JollofProfile from "@/pages/JollofProfile";
import Discovery from "@/pages/Discovery";
import BlogPost from "@/pages/BlogPost";
import Dashboard from "@/pages/Dashboard";
import Partnership from "@/pages/Partnership";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Checkout from "@/pages/Checkout";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import Directory from "@/pages/Directory";
import TrackOrder from "@/pages/TrackOrder";
import ContentPage from "@/pages/ContentPage";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SiteProvider>
        <CartProvider>
          <BrowserRouter>
            <Toaster theme="light" position="top-right" richColors />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/marketplace" element={<Marketplace />} />
                <Route path="/chef/:id" element={<ChefProfile />} />
                <Route path="/jollof" element={<JollofProfile />} />
                <Route path="/discovery" element={<Discovery />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/partners" element={<Partnership />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/about" element={<About />} />
                <Route path="/chefs" element={<Directory type="chef" />} />
                <Route path="/restaurants" element={<Directory type="restaurant" />} />
                <Route path="/track" element={<TrackOrder />} />
                <Route path="/delivery" element={<ContentPage slug="delivery" />} />
                <Route path="/refund" element={<ContentPage slug="refund" />} />
                <Route path="/terms" element={<ContentPage slug="terms" />} />
                <Route path="/privacy" element={<ContentPage slug="privacy" />} />
                <Route path="/sustainability" element={<ContentPage slug="sustainability" />} />
                <Route path="/corporate" element={<ContentPage slug="corporate" />} />
                <Route path="/blog" element={<Discovery />} />
                <Route path="/rewards" element={<ContentPage slug="rewards" />} />
                <Route path="/careers" element={<ContentPage slug="careers" />} />
                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />
              </Route>
            </Routes>
          </BrowserRouter>
        </CartProvider>
        </SiteProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
